import { OktaAuth } from '@okta/okta-auth-js'

const oktaConfig = {
  issuer: process.env.REACT_APP_OKTA_ISSUER!,
  redirectUri: `${window.location.origin}/implicit/callback`,
  clientId: 'nike.niketech.trade-cch-web',
  scopes: ['openid', 'email', 'profile', 'groups'],
  pkce: true,
  // Add token manager configuration for auto-renewal
  tokenManager: {
    autoRenew: true, // Automatically renew tokens before they expire
    autoRemove: true, // Automatically remove expired tokens
    expireEarlySeconds: 300, // Renew 5 minutes before expiration
    syncStorage: true, // Sync tokens across tabs
  },
  services: {
    autoRenew: true, // Enable auto-renewal service
  }
}

export const oktaAuth = new OktaAuth(oktaConfig)
